<template>
    <article
        class="tw:group tw:relative tw:flex tw:items-start tw:gap-3 tw:border-b tw:border-surface-200 tw:bg-surface-0 tw:py-3.5 tw:pr-3 tw:pl-5 tw:text-surface-900 tw:hover:bg-emphasis tw:focus-within:bg-emphasis tw:dark:border-surface-700 tw:dark:bg-surface-900 tw:dark:text-surface-0"
        data-test="deadline-reminder"
    >
        <span
            v-if="!notification.read"
            class="tw:absolute tw:top-[1.6rem] tw:left-1.5 tw:size-1.5 tw:rounded-full tw:bg-primary"
            aria-label="Unread"
            data-test="unread-dot"
        />
        <!-- The same large Avatar as the other bell cards, so every card's text starts in one column. -->
        <Avatar
            icon="pi pi-clock"
            size="large"
            shape="circle"
            class="tw:shrink-0 tw:bg-[var(--p-tag-warn-background)]! tw:text-[var(--p-tag-warn-color)]!"
            aria-hidden="true"
            data-test="deadline-reminder-icon"
        />
        <div class="tw:min-w-0 tw:flex-1">
            <a
                :href="notification.inbox_link"
                :class="[
                    'tw:block tw:text-[0.9rem] tw:leading-5 tw:break-words tw:text-primary',
                    notification.read ? 'tw:font-normal' : 'tw:font-bold',
                ]"
                @click.prevent="$emit('open')"
            >
                {{ notification.title }}
            </a>
            <p class="tw:mt-0.5 tw:text-sm tw:break-words tw:text-surface-700 tw:dark:text-surface-200">{{ notification.course_title }}</p>
            <p class="tw:mt-0.5 tw:text-sm tw:text-surface-700 tw:dark:text-surface-200">
                Due <time :datetime="notification.due_at">{{ notification.deadline }}</time>
            </p>
            <p
                v-if="notification.already_submitted"
                class="tw:mt-0.5 tw:text-sm tw:font-semibold tw:text-surface-900 tw:dark:text-surface-0"
                data-test="already-submitted"
            >
                Already submitted
            </p>
            <p class="tw:mt-0.5 tw:line-clamp-2 tw:text-sm tw:text-surface-700 tw:dark:text-surface-200">{{ notification.body }}</p>
            <a
                :href="notification.inbox_link"
                class="tw:mt-1 tw:inline-block tw:text-sm tw:font-semibold tw:text-primary tw:underline"
                @click.prevent="$emit('open')"
            >
                View Activity
            </a>
            <p class="tw:mt-1 tw:text-xs tw:text-muted-color" data-test="deadline-reminder-meta">
                {{ meta }}
            </p>
        </div>
        <Button
            :icon="notification.read ? 'pi pi-circle' : 'pi pi-check'"
            :aria-label="notification.read ? 'Mark as unread' : 'Mark as read'"
            class="tw:shrink-0 tw:self-center tw:opacity-0 tw:group-hover:opacity-100 tw:group-focus-within:opacity-100 tw:pointer-coarse:opacity-100"
            severity="secondary"
            size="small"
            text
            rounded
            @click="$emit('toggle-read')"
        />
    </article>
</template>

<script setup>
import Avatar from 'primevue/avatar';
import Button from 'primevue/button';
import { computed } from 'vue';

const props = defineProps({
    notification: {
        type: Object,
        required: true,
    },
});

defineEmits(['open', 'toggle-read']);

const meta = computed(() =>
    [props.notification.course_code, 'Deadline reminder', props.notification.relative_created_at]
        .filter(Boolean)
        .join(' · ')
);
</script>
